import { apiBaseUrl } from "./config";

const baseUrl = `${apiBaseUrl}/products`;

async function getMembershipProducts() {
  const url = `${baseUrl}/memberships`;
  const r = await fetch(url);
  const data = await r.json();
  return data;
}

async function getLibroProducts() {
  const url = `${baseUrl}/libros`;
  const r = await fetch(url);
  const data = await r.json();
  return data;
}

export {
  getMembershipProducts,
  getLibroProducts
};
